import useSessionStore from "@features/session/hooks/useSessionStore";
import type { ProethicaPrinciple } from "./constants";
import { proethicaPrinciples } from "./principles-content";

const extractPrinciples = (
	items: { content?: { principles?: ProethicaPrinciple[] } }[],
): ProethicaPrinciple[] =>
	items.find((item) => Boolean(item.content?.principles?.length))?.content
		?.principles ?? [];

// Principles ride on the active session's EXPLORE item, so the live-API swap is
// drop-in. The standalone Principles tab has no session, so it falls back to the
// boundary's default reference set.
export const useProethicaPrinciples = (): ProethicaPrinciple[] => {
	const sessionItems = useSessionStore((state) => state.sessionItems);
	const fromSession = extractPrinciples(sessionItems);
	return fromSession.length ? fromSession : proethicaPrinciples;
};
